var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.errorType === "error message"
      ? _c(
          "div",
          { staticClass: "api-errors" },
          _vm._l(_vm.errors, function (errorObject, key) {
            return _c(
              "div",
              {
                key: key,
                staticClass: "alert alert-danger",
                attrs: { role: "alert" },
              },
              [
                _c("strong", [_vm._v(_vm._s(key) + ":")]),
                _vm._v(" "),
                Array.isArray(errorObject)
                  ? _c(
                      "div",
                      [
                        errorObject.length > 1
                          ? _c(
                              "ul",
                              _vm._l(errorObject, function (err) {
                                return _c("li", { key: err }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(err) +
                                      "\n                    "
                                  ),
                                ])
                              }),
                              0
                            )
                          : [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(errorObject[0]) +
                                  "\n                "
                              ),
                            ],
                      ],
                      2
                    )
                  : _c("div", [
                      _vm._v(
                        "\n                " +
                          _vm._s(errorObject) +
                          "\n            "
                      ),
                    ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.errorType === "error page"
      ? _c(
          "div",
          {
            staticClass:
              "col-sm-12 text-center api-errors content-width container-spacing",
          },
          _vm._l(_vm.errors, function (errorObject, key) {
            return _c("div", { key: key }, [
              _c("h1", { staticClass: "text-info" }, [
                _c("strong", [_vm._v(_vm._s(key))]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                " + _vm._s(errorObject) + "\n            "
                ),
              ]),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }